import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface SubBanner {
  id: number;
  caption: string;
  title: string;
  start_date: string;
  end_date: string;
  active: number | string | boolean;
  cta: string;
  banner_image?: string;
  file_path?: string;
  filename?: string;
  mode?: string;
  status?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ListSubBannersResponse {
  error: boolean;
  banners: SubBanner[];
}

export interface AddSubBannerResponse {
  error: boolean;
  message: string;
  bannerId?: number;
}

export interface UpdateSubBannerResponse {
  error: boolean;
  message: string;
  banner?: SubBanner;
}

export interface DeleteSubBannerResponse {
  error: boolean;
  message: string;
}

export const subBannerApi = createApi({
  reducerPath: 'subBannerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://fftestservice.sarsetech.com/',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey',
        '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      return headers;
    },
  }),
  tagTypes: ['SubBanner'],
  endpoints: (build) => ({
    listSubBanners: build.query<ListSubBannersResponse, void>({
      query: () => ({
        url: 'product/bannerlist',
        method: 'POST',
        body: {},
      }),
      providesTags: ['SubBanner'],
    }),
    addSubBanner: build.mutation<AddSubBannerResponse, FormData>({
      query: (formData) => ({
        url: 'product/banneradd',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['SubBanner'],
    }),
    updateSubBanner: build.mutation<UpdateSubBannerResponse, { id: number; formData: FormData }>({
      query: ({ id, formData }) => {
        // Add the ID to the FormData
        formData.append('id', id.toString());
        return {
          url: 'product/bannerupdate',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['SubBanner'],
    }),
    deleteSubBanner: build.mutation<DeleteSubBannerResponse, number>({
      query: (bannerId) => ({
        url: 'product/bannerdelete',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          id: bannerId.toString(),
        }),
      }),
      invalidatesTags: ['SubBanner'],
    }),
  }),
});

export const {
  useListSubBannersQuery,
  useAddSubBannerMutation,
  useUpdateSubBannerMutation,
  useDeleteSubBannerMutation,
} = subBannerApi;